import { ImportType } from "@mimber/schema"
import type { ImportWizardConfig } from "@/components/blocks/ImportWizardModal"

const FIELD_DEFINITIONS = [
  { key: "firstName", label: "First name", required: true },
  { key: "lastName", label: "Last name", required: true },
  { key: "email", label: "Email", required: true },
]

export const memberInvitationImportConfig: ImportWizardConfig = {
  importType: ImportType.MEMBER_INVITATION_IMPORT,
  title: "Bulk Invite Members",
  description:
    "Send each person an email invitation to create their own account and manage their membership.",
  fieldDefinitions: FIELD_DEFINITIONS,
  templateHeaders: ["First Name", "Last Name", "Email"],
  templateFilename: "member-invitations-template.csv",
  successMessage:
    "The imported members are being processed and you will be emailed once it is completed.",
}
